import React, { useContext, useEffect, useState } from 'react'
import { apiPut, apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import AuthContext from 'context/AuthContext'
import { isEmpty, startCase } from 'lodash'
import helper from '../../../utils/helpers'
import homeImage from '../../../assets/images/home.png'
import Pagination from 'pages/Pagination'
import AgentDetailViewPage from './AgentDetailViewPage'

const AgentTable = ({ companyId, viewShow, setViewShow }) => {
  const [agent, setAgent] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const handleUserView = newItem => {
    setItem(newItem)
    setViewShow(true)
  }

  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const notification = useToastContext()

  const handelStatusChange = async newItem => {
    try {
      const payload = {
        status: newItem?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.statusAgent}/${newItem?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        allAgent()
      }
    } catch (error) {
      console.error('error in get all sub admin list==>>>>', error.message)
    }
  }

  const allAgent = async data => {
    try {
      if (
        data?.deletePage &&
        !(agent?.length > 1)
        // ||(isFilter && category && data?.statusChange && !(agent?.length > 1))
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        page,
        pageSize: pageSize,
        // status: category,
        // startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        // endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        // keyword: searchkey,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        companyId
      }

      const path = apiPath.getCompanyAgentList
      const result = await apiGet(path, payload)

      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAgent(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  useEffect(() => {
    allAgent()
  }, [page, sort])
  return (
    <>
      {!viewShow && (
        <>
          <div className='p-3'>
            <div className='overflow-x-auto relative 
 border'>
              <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
                <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                  <tr>
                    <th scope='col' className='py-3 px-6'>
                      #
                    </th>
                    <th scope='col' className='py-3 px-6 cursor-pointer'>
                      <div className='flex'>
                        <span>{t('O_PROFILE_PICTURE')} </span>
                      </div>
                    </th>
                    <th
                      scope='col'
                      className='py-3 px-6 cursor-pointer'
                      onClick={() => {
                        if (
                          sort.sortKey === 'name' &&
                          sort.sortType === 'asc'
                        ) {
                          setSort({
                            sortKey: 'name',
                            sortType: 'desc'
                          })
                        } else {
                          setSort({
                            sortKey: 'name',
                            sortType: 'asc'
                          })
                        }
                      }}
                    >
                      <div className='flex'>
                        <span>{t('O_FULL_NAME')} </span>
                        <span>
                          {sort.sortKey === 'name' &&
                            sort.sortType === 'asc' && (
                              <BsArrowUpShort className='w-4 h-4' />
                            )}
                          {sort.sortKey === 'name' &&
                            sort.sortType === 'desc' && (
                              <BsArrowUpShort className='w-4 h-4 rotate-180' />
                            )}
                        </span>
                      </div>
                    </th>

                    <th
                      scope='col'
                      className='py-3 px-6 cursor-pointer'
                      onClick={() => {
                        if (
                          sort.sortKey === 'email' &&
                          sort.sortType === 'asc'
                        ) {
                          setSort({
                            sortKey: 'email',
                            sortType: 'desc'
                          })
                        } else {
                          setSort({
                            sortKey: 'email',
                            sortType: 'asc'
                          })
                        }
                      }}
                    >
                      <div className='flex'>
                        <span>{t('O_EMAIL_ADDRESS')} </span>
                        <span>
                          {sort.sortKey === 'email' &&
                            sort.sortType === 'asc' && (
                              <BsArrowUpShort className='w-4 h-4' />
                            )}
                          {sort.sortKey === 'email' &&
                            sort.sortType === 'desc' && (
                              <BsArrowUpShort className='w-4 h-4 rotate-180' />
                            )}
                        </span>
                      </div>
                    </th>
                    <th scope='col' className='py-3 px-6 text-right'>
                      {t('O_COUNTRY_CODE')}
                    </th>
                    <th scope='col' className='py-3 px-6 text-right'>
                      {t('O_MOBILE')}
                    </th>
                    <th scope='col' className='py-3 px-6 text-right'>
                      {t('O_BRN_NUMBER')}
                    </th>
                    <th scope='col' className='py-3 px-6'>
                      {t('AGENT_DESIGNATION')}
                    </th>
                    <th scope='col' className='py-3 px-6 text-right'>
                      {t('No. of property')}
                    </th>
                    <th
                      scope='col'
                      className='py-3 px-6 cursor-pointer text-right'
                      onClick={() => {
                        if (
                          sort.sortKey === 'createdAt' &&
                          sort.sortType === 'asc'
                        ) {
                          setSort({
                            sortKey: 'createdAt',
                            sortType: 'desc'
                          })
                        } else {
                          setSort({
                            sortKey: 'createdAt',
                            sortType: 'asc'
                          })
                        }
                      }}
                    >
                      <div className='flex justify-end'>
                        <span>{t('O_CREATED_AT')} </span>
                        <span>
                          {sort.sortKey === 'createdAt' &&
                            sort.sortType === 'asc' && (
                              <BsArrowUpShort className='w-4 h-4' />
                            )}
                          {sort.sortKey === 'createdAt' &&
                            sort.sortType === 'desc' && (
                              <BsArrowUpShort className='w-4 h-4 rotate-180' />
                            )}
                        </span>
                      </div>
                    </th>

                    <th
                      scope='col'
                      className='py-3 px-6 cursor-pointer text-right'
                      onClick={() => {
                        if (
                          sort.sortKey === 'updatedAt' &&
                          sort.sortType === 'asc'
                        ) {
                          setSort({
                            sortKey: 'updatedAt',
                            sortType: 'desc'
                          })
                        } else {
                          setSort({
                            sortKey: 'updatedAt',
                            sortType: 'asc'
                          })
                        }
                      }}
                    >
                      <div className='flex justify-end'>
                        {t('O_UPDATED_AT')}
                        {sort.sortKey === 'updatedAt' &&
                          sort.sortType === 'asc' && (
                            <BsArrowUpShort className='w-4 h-4' />
                          )}
                        {sort.sortKey === 'updatedAt' &&
                          sort.sortType === 'desc' && (
                            <BsArrowUpShort className='w-4 h-4 rotate-180' />
                          )}
                      </div>
                    </th>
                    {(user?.permission?.find(e => e.manager === 'agent_manager')
                      ?.add ||
                      user?.permission?.length === 0) && (
                      <th scope='col' className='py-3 px-6 text-center'>
                        {' '}
                        {t('O_STATUS')}
                      </th>
                    )}
                    <th scope='col' className='py-3 px-6 text-center'>
                      {t('O_ACTION')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {agent?.map((item, i) => (
                    <tr
                      key={i}
                      className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                    >
                      <th
                        scope='row'
                        className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                      >
                        {i + 1 + 10 * (paginationObj?.page - 1)}
                      </th>
                      <td className='py-3 px-6 text-black text-base border-r'>
                        <div className='flex justify-center space-x-4'>
                          <img
                            alt=''
                            className='w-10 h-10'
                            src={item?.profilePic}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null
                              currentTarget.src = homeImage
                            }}
                          />
                          <div>{item?.orderId}</div>
                        </div>
                      </td>
                      <td className='py-2 px-2 border-r'>
                        {startCase(item?.firstName + item?.lastName)}{' '}
                      </td>
                      <td className='py-2 px-2 border-r'>
                        {item?.email}
                        <span
                          className={`${
                            item?.is_email_verified === 1
                              ? 'text-green-600 block '
                              : 'text-red-600 block'
                          }`}
                        >
                          {item?.is_email_verified === 1
                            ? '(Verified)'
                            : '(Not Verified)'}
                        </span>
                      </td>
                      <td className='py-2 px-2 border-r text-right'>
                        {item?.countryCode}{' '}
                      </td>
                      <td className='py-2 px-2 border-r text-right'>
                        {item?.mobile}
                        <span
                          className={`${
                            item?.is_mobile_verified === 1
                              ? 'text-green-600 block'
                              : 'text-red-600 block'
                          }`}
                        >
                          {item?.is_mobile_verified === 1
                            ? '(Verified)'
                            : '(Not Verified)'}
                        </span>
                      </td>
                      <td className='py-2 px-2 border-r text-right'>
                        {item?.brn || 'N/A'}
                      </td>
                      <td className='py-2 px-2 border-r'>
                        {item?.designation}
                      </td>
                      <td className='py-2 px-2 border-r'>
                        {item?.properties.length}
                      </td>
                      <td className='py-2 px-2 border-r text-right'>
                        {helper.dateFormat(item?.createdAt)}
                      </td>
                      <td className='py-2 px-2 border-r text-right'>
                        {helper.dateFormat(item?.updatedAt)}{' '}
                      </td>
                      {(user?.permission?.find(
                        e => e.manager === 'agent_manager'
                      )?.add ||
                        user?.permission?.length === 0) && (
                        <td className='py-2 px-2 border-r text-center'>
                          <label
                            className='inline-flex relative items-center '
                            // title={t('O_STATUS')}
                            title={`${
                              item?.status === 'active' ? 'Active' : 'Inactive'
                            }`}
                          >
                            <input
                              type='checkbox'
                              // value={status}
                              className='sr-only peer'
                              checked={item?.status === 'active'}
                              onChange={e =>
                                helper.alertFunction(
                                  `Are you sure want to ${
                                    e.target.checked ? 'active' : 'inactive'
                                  } ${item?.firstName} ${item?.lastName}?`,
                                  item,
                                  handelStatusChange
                                )
                              }
                            />
                            <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                          </label>
                        </td>
                      )}
                      <td className='py-4 px-6 border-l'>
                        <div className=''>
                          <ul className='flex justify-center'>
                            {/* <NavLink
                            className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                            // onClick={() => handleUserView(item)}
                            to='/company/agent/view'
                            state={{item}}
                          >
                            <AiFillEye className=' w-5 h-5 text-slate-600' />{' '}
                          </NavLink> */}
                            <li
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                              onClick={() => handleUserView(item)}
                              // to='/company/agent/view'
                              // state={{item}}
                            >
                              <AiFillEye className=' w-5 h-5 text-slate-600' />{' '}
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {isEmpty(agent) && (
                    <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                      <td className='py-4 px-6' colSpan={12}>
                        {t('O_NO_RECORD_FOUND')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {paginationObj?.totalItems !== 0 && (
            <Pagination
              handlePageClick={handlePageClick}
              options={paginationObj}
              page={page}
            />
          )}
        </>
      )}

      {viewShow && (
        <AgentDetailViewPage setViewShow={setViewShow} item={item} />
      )}
    </>
  )
}

export default AgentTable
